import { Box, Typography, useTheme } from '@mui/material';
import { isEmpty } from 'lodash';

// Components
import dayjs from 'dayjs';
import ExpandableBox from 'src/components/common/ExpandableBox';
import TranslateText from 'src/components/common/TranslateText';
import TableHorizontal from 'src/components/TableHorizontal';
import { FORMAT_DATE_TIME } from 'src/utils/constants/config';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';

// Utilities

const Description = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const theme = useTheme();

  const configColumn = [
    {
      label: 'BL Identification Number',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.transaction?.bol),
      renderCell: (data: IBillOfLadingDetail) => (
        <>
          <Typography color={'text.secondary'} variant="body2">
            {renderTextOrDefault(data?.transaction?.bol)}
          </Typography>
        </>
      ),
    },
    {
      label: 'HS Code',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.hs_code),
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {renderTextOrDefault(data?.transaction?.hs_code)}
        </Typography>
      ),
    },
    {
      label: 'Description',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.transaction?.description),
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          <TranslateText
            render={(text) => (
              <Typography color={'text.secondary'} variant="body2">
                {text}
              </Typography>
            )}
            text={data.transaction?.description}
          />
        </Typography>
      ),
    },
    {
      label: 'Arrival Date',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.transaction?.created_at),
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {dayjs(data?.transaction?.actual_arrival_date?.toString(), FORMAT_DATE_TIME.yyyy_mm_dd).format(
            FORMAT_DATE_TIME.FULL_ONLY_DATE,
          )}
        </Typography>
      ),
    },
  ];

  return (
    <ExpandableBox title="Description" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={theme.palette.background.default}
        borderRadius={`0px 0px ${theme.shape.borderRadius * 2}px ${theme.shape.borderRadius * 2}px`}
      >
        <TableHorizontal colKeyWidth={350} configColumn={configColumn} data={tradeDataDetail} />
      </Box>
    </ExpandableBox>
  );
};

export default Description;
